import React from 'react'
import MM_Logo_Positive from "../../assets/images/MM_Logo_Positive.png"
import Group_logo from "../../assets/images/Group_624.png"
import { Box, Typography } from '@mui/material'
const MobileViewPage = () => {
    return (
        <Box sx={{
            width: "100%",
            height: '100%'
        }}>
            <Box
                component="img"
                sx={{
                    width: "100%",
                    padding: "13% 15%",
                }}
                alt=""
                src={MM_Logo_Positive}
            />
            <Box
                component="img"
                sx={{
                    width: "100%",
                    padding: "0% 15% 12% 15%",
                }}
                alt=""
                src={Group_logo}
            />
            <Typography style={{
                fontSize: '24px',
                display: 'flex',
                textAlign: "center",
                padding: '0 6%'
            }}>
                The mobile version is not compatible.
                Please use the desktop or tablet view to open.
            </Typography>
        </Box>
    )
}

export default MobileViewPage